(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ba-compare]').forEach(function (root) {
      var beforeImg = root.querySelector('.ba-compare__before');
      var afterImg = root.querySelector('.ba-compare__after');
      var handle = root.querySelector('[data-ba-handle]');
      if (!beforeImg || !afterImg || !handle) return;
      var dragging = false;
      function setPos(clientX) {
        var rect = root.getBoundingClientRect();
        var x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
        var pct = (x / rect.width) * 100;
        beforeImg.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        afterImg.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        handle.style.left = pct + '%';
      }
      root.addEventListener('pointerdown', function (e) {
        dragging = true;
        setPos(e.clientX);
        root.setPointerCapture(e.pointerId);
      });
      root.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        setPos(e.clientX);
      });
      root.addEventListener('pointerup', function () { dragging = false; });
      root.addEventListener('pointercancel', function () { dragging = false; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function syncFooterAccordions() {
      var isMobile = window.matchMedia('(max-width: 767px)').matches;
      var items = document.querySelectorAll('.section-footer .footer-accordion');
      items.forEach(function (d) {
        if (isMobile) {
          if (!d.dataset.userToggled) d.removeAttribute('open');
        } else {
          d.setAttribute('open', '');
        }
      });
    }
    syncFooterAccordions();

    document.querySelectorAll('.section-footer .footer-accordion summary').forEach(function (s) {
      s.addEventListener('click', function () {
        var d = s.parentElement;
        if (d) d.dataset.userToggled = '1';
      });
    });

    window.addEventListener('resize', function () {
      window.requestAnimationFrame(syncFooterAccordions);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document;

    (function () {
      const hdr = root.getElementById('site-header');
      if (!hdr || hdr.dataset.transparent !== 'true') return;
      let ticking = false;
      function update() {
        const scrolled = window.scrollY > 50;
        hdr.dataset.scrolled = scrolled ? 'true' : 'false';
        const logoImg = hdr.querySelector('img[data-logo-img]');
        if (logoImg && hdr.dataset.logoDark && hdr.dataset.logoLight) {
          logoImg.src = scrolled ? hdr.dataset.logoDark : hdr.dataset.logoLight;
        }
        ticking = false;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }, { passive: true });
      update();
    })();

    function openDialog(id, trigger) {
      const dlg = root.getElementById(id);
      if (!dlg || typeof dlg.showModal !== 'function') return;
      if (!dlg.open) dlg.showModal();
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function closeDialog(id, trigger) {
      const dlg = root.getElementById(id);
      if (!dlg) return;
      if (dlg.open) dlg.close();
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    root.addEventListener('click', function (e) {
      const opener = e.target.closest('[data-toggle]');
      if (opener) {
        e.preventDefault();
        const id = opener.getAttribute('data-toggle');
        openDialog(id, opener);
        return;
      }
      const closer = e.target.closest('[data-close]');
      if (closer) {
        e.preventDefault();
        const id = closer.getAttribute('data-close');
        const trig = root.querySelector('[data-toggle="' + id + '"]');
        closeDialog(id, trig);
      }
    });

    root.querySelectorAll('dialog').forEach(function (dlg) {
      dlg.addEventListener('click', function (e) {
        const panel = dlg.querySelector('[class*="__panel"]');
        if (panel && !panel.contains(e.target)) {
          dlg.close();
          const trig = root.querySelector('[data-toggle="' + dlg.id + '"]');
          if (trig) trig.setAttribute('aria-expanded', 'false');
        }
      });
      dlg.addEventListener('close', function () {
        const trig = root.querySelector('[data-toggle="' + dlg.id + '"]');
        if (trig) trig.setAttribute('aria-expanded', 'false');
      });
    });

    (function () {
      const menus = root.querySelectorAll('details[data-account-menu]');
      if (!menus.length) return;
      const closeAll = function (except) {
        menus.forEach(function (m) { if (m !== except) m.open = false; });
      };
      const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      menus.forEach(function (menu) {
        if (supportsHover) {
          let closeTimer;
          menu.addEventListener('mouseenter', function () {
            clearTimeout(closeTimer);
            closeAll(menu);
            menu.open = true;
          });
          menu.addEventListener('mouseleave', function () {
            closeTimer = setTimeout(function () { menu.open = false; }, 150);
          });
        }
        menu.addEventListener('toggle', function () {
          if (menu.open) closeAll(menu);
        });
      });
      root.addEventListener('click', function (e) {
        menus.forEach(function (menu) {
          if (menu.open && !menu.contains(e.target)) menu.open = false;
        });
      });
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero-slider]').forEach(function (root) {
    const track = root.querySelector('[data-hero-track]');
    if (!track) return;
    const originals = Array.from(track.querySelectorAll('.hero-slide'));
    if (originals.length <= 1) return;
    const dots = root.querySelectorAll('[data-hero-dot]');
    const total = originals.length;
    const autoplay = root.dataset.autoplay === 'true';
    const interval = parseInt(root.dataset.interval, 10) || 5000;

    // Loop sin animación-backwards: clonamos primer slide al final y último al principio.
    // Layout final del track: [last_clone, s1, s2, s3, first_clone]
    const firstClone = originals[0].cloneNode(true);
    const lastClone = originals[total - 1].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    track.appendChild(firstClone);
    track.insertBefore(lastClone, originals[0]);

    let realIndex = 0;          // 0..total-1 (slide visible "real")
    let trackIndex = 1;         // posición en el track (0 = last_clone, 1..total = reales, total+1 = first_clone)
    let timer = null;
    let animating = false;

    function applyTransform(animate) {
      track.style.transition = animate ? '' : 'none';
      track.style.transform = 'translateX(-' + (trackIndex * 100) + '%)';
    }
    function updateDots() {
      dots.forEach(function (d) {
        const active = parseInt(d.dataset.heroDot, 10) === realIndex;
        d.setAttribute('data-active', active ? 'true' : 'false');
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
    function go(dir) {
      // dir: +1 next, -1 prev, o un número absoluto entre 0..total-1 (clic en dot)
      if (animating) return;
      if (typeof dir === 'number' && Math.abs(dir) !== 1) {
        // absoluto desde dots
        realIndex = dir;
        trackIndex = realIndex + 1;
        applyTransform(true);
        updateDots();
        return;
      }
      animating = true;
      trackIndex += dir;
      applyTransform(true);
      realIndex = (realIndex + dir + total) % total;
      updateDots();
      const onEnd = function () {
        track.removeEventListener('transitionend', onEnd);
        if (trackIndex === total + 1) {
          // pasamos del first_clone, saltamos al real primer slide sin animación
          trackIndex = 1;
          applyTransform(false);
        } else if (trackIndex === 0) {
          // pasamos del last_clone, saltamos al real último sin animación
          trackIndex = total;
          applyTransform(false);
        }
        animating = false;
      };
      track.addEventListener('transitionend', onEnd, { once: true });
    }
    function next() { go(1); }
    function prev() { go(-1); }
    function start() { if (!autoplay) return; stop(); timer = setInterval(next, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    // Init: posiciono el track en el primer slide REAL (no en el clon)
    applyTransform(false);
    updateDots();
    // Re-query slides incluyendo clones para que el código de swipe siga funcionando
    const slides = track.querySelectorAll('.hero-slide');

    root.querySelector('[data-hero-prev]')?.addEventListener('click', function () { prev(); start(); });
    root.querySelector('[data-hero-next]')?.addEventListener('click', function () { next(); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.heroDot, 10)); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    // Swipe (touch + mouse drag on desktop)
    let dragStartX = 0;
    let dragging = false;
    let movedDistance = 0;
    const THRESHOLD = 40;

    function dragStart(x) {
      dragStartX = x;
      dragging = true;
      movedDistance = 0;
      stop();
      track.style.transition = 'none';
      track.style.cursor = 'grabbing';
    }
    function dragMove(x) {
      if (!dragging) return;
      const dx = x - dragStartX;
      movedDistance = Math.abs(dx);
      const w = track.clientWidth;
      const pct = (dx / w) * 100;
      track.style.transform = 'translateX(' + (-trackIndex * 100 + pct) + '%)';
    }
    function dragEnd(x) {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      track.style.cursor = 'grab';
      const dx = x - dragStartX;
      if (Math.abs(dx) > THRESHOLD) { (dx < 0 ? next : prev)(); }
      else { applyTransform(true); }
      start();
    }

    // Touch
    track.addEventListener('touchstart', function (e) { dragStart(e.touches[0].clientX); }, { passive: true });
    track.addEventListener('touchmove', function (e) { dragMove(e.touches[0].clientX); }, { passive: true });
    track.addEventListener('touchend', function (e) { dragEnd(e.changedTouches[0].clientX); });

    // Mouse (desktop) — incluso si target es <a>, iniciamos drag tracking
    // pero solo bloqueamos el click si moved > THRESHOLD
    track.style.cursor = 'grab';
    track.style.userSelect = 'none';
    track.addEventListener('mousedown', function (e) {
      // Solo skip si target es un botón explícito (prev/next/dot)
      if (e.target.closest('[data-hero-prev],[data-hero-next],[data-hero-dot]')) return;
      dragStart(e.clientX);
    });
    // Prevenir el drag de imagen nativa cuando arrastras
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    document.addEventListener('mousemove', function (e) { if (dragging) dragMove(e.clientX); });
    document.addEventListener('mouseup', function (e) { if (dragging) dragEnd(e.clientX); });
    // Prevent click-through on links only when actually dragged > THRESHOLD
    track.addEventListener('click', function (e) {
      if (movedDistance > THRESHOLD) {
        e.preventDefault();
        e.stopPropagation();
      }
      movedDistance = 0;
    }, true);

    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCollDesc(root) {
      (root || document).querySelectorAll('[data-coll-desc-section]').forEach(function (sec) {
        if (sec.dataset.collDescInit === '1') return;
        sec.dataset.collDescInit = '1';
        var body = sec.querySelector('[data-coll-desc-body]');
        var toggle = sec.querySelector('[data-coll-desc-toggle]');
        if (!body || !toggle) return;

        // Hide toggle if content fits — measure with body briefly uncollapsed
        body.classList.remove('is-collapsed');
        var naturalH = body.scrollHeight;
        body.classList.add('is-collapsed');
        if (naturalH <= 180) {
          toggle.style.display = 'none';
          body.classList.remove('is-collapsed');
        }
      });
    }

    // Delegación: funciona aunque el handler se enganche antes de que exista el botón
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest && e.target.closest('[data-coll-desc-toggle]');
      if (!toggle) return;
      var sec = toggle.closest('[data-coll-desc-section]');
      var body = sec && sec.querySelector('[data-coll-desc-body]');
      if (!body) return;
      e.preventDefault();
      var nowExpanded = !body.classList.contains('is-expanded');
      body.classList.toggle('is-expanded', nowExpanded);
      body.classList.toggle('is-collapsed', !nowExpanded);
      toggle.setAttribute('aria-expanded', String(nowExpanded));
      var moreEl = toggle.querySelector('[data-toggle-more]');
      var lessEl = toggle.querySelector('[data-toggle-less]');
      var chev = toggle.querySelector('[data-toggle-chev]');
      if (moreEl) moreEl.classList.toggle('hidden', nowExpanded);
      if (lessEl) lessEl.classList.toggle('hidden', !nowExpanded);
      if (chev) chev.style.transform = nowExpanded ? 'rotate(180deg)' : '';
    });

    // Medición DOM-ready (y re-init en el editor de temas)
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initCollDesc(); });
    } else {
      initCollDesc();
    }
    document.addEventListener('shopify:section:load', function (e) { initCollDesc(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  /* Movil/iOS: mostrar el primer fotograma como portada de los videos de la descripcion.
     Sin atributo poster, iOS pinta un hueco gris con el play; el fragmento #t=0.1 fuerza ese frame. */
  (function () {
    document.querySelectorAll('.pdp-desc video').forEach(function (v) {
      if (v.getAttribute('poster')) return;
      v.setAttribute('playsinline', '');
      if (!v.getAttribute('preload')) v.setAttribute('preload', 'metadata');
      var src = v.getAttribute('src');
      if (src && src.indexOf('#') === -1) {
        v.setAttribute('src', src + '#t=0.1');
        v.load();
      } else {
        var s = v.querySelector('source');
        if (s && s.getAttribute('src') && s.getAttribute('src').indexOf('#') === -1) {
          s.setAttribute('src', s.getAttribute('src') + '#t=0.1');
          v.load();
        }
      }
    });
  })();

  (function () {
    const mainWrap = document.querySelector('[data-main-media]');
    if (!mainWrap) return;
    const mainMedia = mainWrap.querySelector('img');
    const thumbs = Array.from(document.querySelectorAll('[data-thumb]'));
    const galleryId = mainWrap.dataset.galleryId;
    const dataNode = galleryId ? document.querySelector('[data-gallery-data="' + galleryId + '"]') : null;
    let gallery = [];
    try { gallery = dataNode ? JSON.parse(dataNode.textContent.trim()) : []; } catch (e) { gallery = []; }
    let currentIndex = 0;
    const hasMulti = gallery.length > 1;

    function setActive(i) {
      if (gallery.length <= 1) return;
      currentIndex = (i + gallery.length) % gallery.length;
      if (mainMedia) {
        mainMedia.src = gallery[currentIndex].src;
        mainMedia.alt = gallery[currentIndex].alt || '';
        // Clear srcset so the new src is the one actually displayed
        mainMedia.removeAttribute('srcset');
        mainMedia.removeAttribute('sizes');
      }
      thumbs.forEach(function (t) {
        t.setAttribute('data-active', String(parseInt(t.dataset.thumbIndex, 10) === currentIndex));
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); setActive(parseInt(t.dataset.thumbIndex, 10) || 0); });
    });

    // Lightbox (native <dialog> + ::backdrop)
    const lb = document.querySelector('[data-gallery-lightbox]');
    const lbAvailable = lb && typeof lb.showModal === 'function';
    let lbImg, lbCounter, lbPrev, lbNext;
    let lbIndex = 0;

    if (lbAvailable) {
      lbImg = lb.querySelector('[data-lightbox-image]');
      lbCounter = lb.querySelector('[data-lightbox-counter]');
      lbPrev = lb.querySelector('[data-lightbox-prev]');
      lbNext = lb.querySelector('[data-lightbox-next]');

      // Hide lightbox nav + counter when only 1 image
      if (!hasMulti) {
        if (lbPrev) lbPrev.style.display = 'none';
        if (lbNext) lbNext.style.display = 'none';
        if (lbCounter) lbCounter.style.display = 'none';
      }
    }

    function renderLb(i) {
      if (!lbAvailable || !gallery.length) return;
      lbIndex = (i + gallery.length) % gallery.length;
      lbImg.src = gallery[lbIndex].src;
      lbImg.alt = gallery[lbIndex].alt || '';
      lbImg.classList.remove('is-zoomed');
      lbImg.style.transformOrigin = 'center center';
      if (lbCounter) lbCounter.textContent = (lbIndex + 1) + ' / ' + gallery.length;
    }
    function openLb(i) { if (!lbAvailable) return; renderLb(i); lb.showModal(); }
    function closeLb() { if (lbAvailable) lb.close(); }

    // Single delegated click handler on mainWrap:
    // - prev/next button → swap image, no lightbox
    // - anywhere else → open lightbox
    mainWrap.addEventListener('click', function (e) {
      const navBtn = e.target.closest('[data-gallery-prev],[data-gallery-next]');
      if (navBtn) {
        e.preventDefault();
        e.stopPropagation();
        const dir = navBtn.hasAttribute('data-gallery-next') ? 1 : -1;
        setActive(currentIndex + dir);
        return;
      }
      if (gallery.length) openLb(currentIndex);
    });

    if (lbAvailable) {
      lb.querySelector('[data-lightbox-close]').addEventListener('click', closeLb);
      if (lbPrev) lbPrev.addEventListener('click', function (e) { e.stopPropagation(); renderLb(lbIndex - 1); });
      if (lbNext) lbNext.addEventListener('click', function (e) { e.stopPropagation(); renderLb(lbIndex + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      lbImg.addEventListener('click', function (e) {
        e.stopPropagation();
        const zooming = !lbImg.classList.contains('is-zoomed');
        lbImg.style.transformOrigin = ((e.offsetX / lbImg.clientWidth) * 100) + '% ' + ((e.offsetY / lbImg.clientHeight) * 100) + '%';
        lbImg.classList.toggle('is-zoomed', zooming);
      });
      document.addEventListener('keydown', function (e) {
        if (!lb.open) return;
        if (e.key === 'ArrowLeft') renderLb(lbIndex - 1);
        else if (e.key === 'ArrowRight') renderLb(lbIndex + 1);
      });
    }

    document.querySelectorAll('[data-qty-input]').forEach(function (input) {
      const wrap = input.closest('div');
      wrap.querySelector('[data-qty-minus]').addEventListener('click', function () {
        const v = Math.max(1, parseInt(input.value, 10) - 1);
        input.value = v;
      });
      wrap.querySelector('[data-qty-plus]').addEventListener('click', function () {
        input.value = parseInt(input.value, 10) + 1;
      });
    });

    // Acordeón de producto: efecto suave de apertura/cierre (degrada a nativo si no hay JS o se prefiere menos movimiento)
    (function () {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      document.querySelectorAll('.pdp-acc__item').forEach(function (item) {
        var head = item.querySelector('.pdp-acc__head');
        var body = item.querySelector('.pdp-acc__body');
        if (!head || !body) return;
        var anim = null;
        head.addEventListener('click', function (e) {
          if (reduce) return;
          e.preventDefault();
          if (anim) anim.cancel();
          if (!item.open) {
            item.open = true;
            var h = body.scrollHeight;
            body.style.overflow = 'hidden';
            anim = body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 300, easing: 'cubic-bezier(.4,0,.2,1)' });
            anim.onfinish = function () { body.style.height = ''; body.style.overflow = ''; anim = null; };
          } else {
            var h2 = body.scrollHeight;
            body.style.overflow = 'hidden';
            anim = body.animate([{ height: h2 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 260, easing: 'cubic-bezier(.4,0,.2,1)' });
            anim.onfinish = function () { item.open = false; body.style.height = ''; body.style.overflow = ''; anim = null; };
          }
        });
      });
    })();

    // Personalizador: al seleccionar el bloque de pestanas se abren todas.
    // Si no, se selecciona el bloque y no se ve nada: el acordeon nace plegado salvo
    // la primera pestana, y la imagen de "How to use" vive en la segunda.
    if (window.Shopify && window.Shopify.designMode) {
      var accDe = function (e) {
        var t = e.target;
        if (!t || typeof t.querySelector !== 'function') return null;
        return t.matches && t.matches('[data-product-accordion]')
          ? t
          : t.querySelector('[data-product-accordion]');
      };
      document.addEventListener('shopify:block:select', function (e) {
        var acc = accDe(e);
        if (!acc) return;
        acc.querySelectorAll('details').forEach(function (d) { d.open = true; });
        acc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      document.addEventListener('shopify:block:deselect', function (e) {
        var acc = accDe(e);
        if (!acc) return;
        acc.querySelectorAll('details').forEach(function (d, i) { d.open = i === 0; });
      });
    }

    // Variant picker: reacciona al cambio de variante (precio, disponibilidad, id, etiquetas)
    (function () {
      const form = document.getElementById('product-form');
      if (!form) return;
      const variantNode = form.querySelector('[data-variant-data]');
      if (!variantNode) return;
      let variants = [];
      try { variants = JSON.parse(variantNode.textContent.trim()) || []; } catch (e) { variants = []; }
      if (!variants.length) return;

      const idInput = form.querySelector('input[name="id"]');
      const optionRadios = Array.from(form.querySelectorAll('input[type="radio"][name^="options["]'));

      const priceBlock = document.querySelector('[data-price-block]');
      const currentPriceEl = priceBlock ? priceBlock.querySelector('[data-current-price]') : null;
      const comparePriceEl = priceBlock ? priceBlock.querySelector('[data-compare-price]') : null;
      const atcBtn = document.querySelector('[data-atc-anchor]');
      const moneyFormat = (variantNode && variantNode.dataset.moneyFormat) || '';

      function formatMoney(cents) {
        const value = (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        if (moneyFormat && moneyFormat.indexOf('{{') !== -1) {
          return moneyFormat.replace(/\{\{\s*[a-z_]+\s*\}\}/i, value);
        }
        return value + ' €';
      }

      if (!optionRadios.length) return;

      function selectedOptions() {
        const opts = [];
        optionRadios.forEach(function (r) {
          if (r.checked) {
            const m = r.name.match(/options\[(.+)\]/);
            opts.push({ name: m ? m[1] : r.name, value: r.value });
          }
        });
        return opts;
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return opts.every(function (o, i) { return v.options[i] === o.value; });
        });
      }

      function updateSelectedLabels() {
        optionRadios.forEach(function (r) {
          if (!r.checked) return;
          const fieldset = r.closest('fieldset');
          if (!fieldset) return;
          const label = fieldset.querySelector('[data-selected-value]');
          if (label) label.textContent = r.value;
        });
      }

      function updateVariant() {
        updateSelectedLabels();
        const variant = findVariant(selectedOptions());
        if (!variant) {
          if (atcBtn) { atcBtn.setAttribute('disabled', 'disabled'); atcBtn.textContent = atcBtn.dataset.tUnavailable || 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = variant.id;

        if (currentPriceEl) currentPriceEl.textContent = formatMoney(variant.price);
        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = formatMoney(variant.compare_at_price);
            comparePriceEl.hidden = false;
          } else {
            comparePriceEl.textContent = '';
            comparePriceEl.hidden = true;
          }
        }

        if (atcBtn) {
          if (variant.available) {
            atcBtn.removeAttribute('disabled');
            atcBtn.textContent = 'Add to cart';
          } else {
            atcBtn.setAttribute('disabled', 'disabled');
            atcBtn.textContent = 'Sold out';
          }
        }

        // Cambio de imagen por variante: busca el media en la galería y lo activa
        if (variant.featured_media && variant.featured_media.id) {
          const mediaId = variant.featured_media.id;
          const idx = gallery.findIndex(function (g) { return g.id === mediaId; });
          if (idx >= 0) {
            setActive(idx);
          } else if (mainMedia && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
            mainMedia.src = variant.featured_media.preview_image.src;
            mainMedia.removeAttribute('srcset');
            mainMedia.removeAttribute('sizes');
          }
        }
      }

      optionRadios.forEach(function (r) {
        r.addEventListener('change', updateVariant);
      });
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DAY = 86400000;

    function initPopup(root) {
      if (root.dataset.ktNlpReady === '1') return;
      root.dataset.ktNlpReady = '1';

      var key = root.dataset.storageKey || 'kt-nlp';
      var days = parseInt(root.dataset.days, 10);
      var delay = parseInt(root.dataset.delay, 10);
      var hideMobile = root.dataset.hideMobile === 'true';
      var inEditor = !!(window.Shopify && window.Shopify.designMode);

      var form = root.querySelector('form');
      var errorEl = root.querySelector('[data-kt-nlp-error]');
      var ticketCode = root.querySelector('[data-kt-nlp-code]');
      var ticketDashes = root.querySelector('[data-kt-nlp-dashes]');
      var copyBtn = root.querySelector('[data-kt-nlp-copy]');
      var successEl = root.querySelector('[data-kt-nlp-success]');
      var lastFocused = null;

      function store(value) {
        try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
      }
      function read() {
        try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; }
      }

      function open() {
        lastFocused = document.activeElement;
        root.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var focusTarget = root.querySelector('input[type="email"]') || root.querySelector('[data-kt-nlp-close]');
        if (focusTarget && !root.classList.contains('is-done')) {
          try { focusTarget.focus({ preventScroll: true }); } catch (e) { focusTarget.focus(); }
        }
      }

      function close(remember) {
        root.hidden = true;
        document.documentElement.style.overflow = '';
        if (remember !== false && !inEditor) {
          var prev = read() || {};
          if (prev.state !== 'subscribed') store({ state: 'closed', at: Date.now() });
        }
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }

      function reveal() {
        root.classList.add('is-done');
        if (ticketDashes) ticketDashes.hidden = true;
        if (ticketCode) ticketCode.hidden = false;
        if (copyBtn) copyBtn.hidden = false;
        if (successEl && successEl.textContent.trim()) successEl.hidden = false;
        store({ state: 'subscribed', at: Date.now() });
      }

      function shouldShow() {
        if (inEditor) return true;
        if (hideMobile && window.matchMedia('(max-width: 749px)').matches) return false;
        var saved = read();
        if (!saved) return true;
        if (saved.state === 'subscribed') return false;
        if (!days || isNaN(days)) return false;
        return Date.now() - (saved.at || 0) > days * DAY;
      }

      root.querySelectorAll('[data-kt-nlp-close]').forEach(function (el) {
        el.addEventListener('click', function () { close(true); });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !root.hidden) close(true);
      });

      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var text = copyBtn.dataset.copy || '';
          var done = function () {
            copyBtn.textContent = copyBtn.dataset.labelCopied || 'Copied';
            setTimeout(function () {
              copyBtn.textContent = copyBtn.dataset.labelCopy || 'Copy';
            }, 2000);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(done, done);
          } else {
            var ta = document.createElement('textarea');
            ta.value = text;
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand('copy'); } catch (e) {}
            document.body.removeChild(ta);
            done();
          }
        });
      }

      // Envio NATIVO a proposito: /contact esta protegido por el captcha invisible de
      // Shopify, que solo inyecta su token en un submit real. Por AJAX responde
      // 400 "Missing CAPTCHA token". Shopify vuelve luego con ?customer_posted=true
      // y ahi revelamos el codigo.
      if (form) {
        form.addEventListener('submit', function () {
          var btn = form.querySelector('button[type="submit"]');
          // OJO: deshabilitar el boton de forma sincrona dentro del submit
          // aborta el envio en Chrome. Se hace en el siguiente tick.
          if (btn) {
            window.setTimeout(function () { btn.disabled = true; }, 0);
            window.setTimeout(function () { btn.disabled = false; }, 8000);
          }
          try { sessionStorage.setItem(key + '-pending', '1'); } catch (e) {}
        });
      }

      var volvioDeEnvio = /[?&]customer_posted=true/.test(window.location.search);
      var pendiente = false;
      try { pendiente = sessionStorage.getItem(key + '-pending') === '1'; } catch (e) {}

      if (volvioDeEnvio) {
        try { sessionStorage.removeItem(key + '-pending'); } catch (e) {}
        reveal();
        open();
        return;
      }

      // Si volvio sin el parametro pero habia un envio en curso y el servidor
      // devolvio errores, los pinta el propio formulario: abrimos el popup.
      if (pendiente && root.querySelector('.kt-nlp__error:not([hidden])')) {
        try { sessionStorage.removeItem(key + '-pending'); } catch (e) {}
        open();
        return;
      }

      if (!shouldShow()) return;
      if (inEditor) { open(); return; }
      window.setTimeout(open, (isNaN(delay) ? 6 : delay) * 1000);
    }

    function boot() {
      document.querySelectorAll('[data-kt-nlp]').forEach(initPopup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-products-carousel]').forEach(function (root) {
      var uid = root.getAttribute('data-products-carousel');
      var track = root.querySelector('[data-carousel-track="' + uid + '"]');
      var prevBtn = root.querySelector('[data-carousel-prev="' + uid + '"]');
      var nextBtn = root.querySelector('[data-carousel-next="' + uid + '"]');
      if (!track || !prevBtn || !nextBtn) return;
      var inner = track.firstElementChild;
      if (!inner) return;

      var originalCount = inner.children.length;
      if (originalCount <= 1) return;

      function getStep() {
        var firstChild = inner.firstElementChild;
        if (!firstChild) return track.clientWidth * 0.8;
        return firstChild.getBoundingClientRect().width + 24;
      }

      // Loop infinito sin animación-backwards: clonamos suficientes items para llenar la viewport al final
      var GAP = 24;
      function buildClones() {
        // Limpia clones previos (en resize)
        Array.prototype.slice.call(inner.querySelectorAll('[data-carousel-clone]')).forEach(function (n) { n.remove(); });
        var step = getStep();
        var visible = Math.max(1, Math.ceil(track.clientWidth / step));
        var originals = Array.prototype.slice.call(inner.children).slice(0, originalCount);
        for (var i = 0; i < visible; i++) {
          var clone = originals[i % originalCount].cloneNode(true);
          clone.setAttribute('data-carousel-clone', 'true');
          clone.setAttribute('aria-hidden', 'true');
          inner.appendChild(clone);
        }
      }

      buildClones();

      function originalsWidth() {
        var step = getStep();
        return originalCount * step;
      }

      function next() {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      }
      function prev() {
        // Si estamos al inicio, saltamos al "final clonado" instantáneo y luego retrocedemos
        if (track.scrollLeft <= 1) {
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = originalsWidth();
          track.style.scrollBehavior = '';
          requestAnimationFrame(function () {
            track.scrollBy({ left: -getStep(), behavior: 'smooth' });
          });
          return;
        }
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      }

      // Cuando el scroll pasa los originales, salto invisible al inicio
      var lastScroll = 0;
      var scrollTimer = null;
      track.addEventListener('scroll', function () {
        var w = originalsWidth();
        if (track.scrollLeft >= w) {
          // Detectar fin del momentum scroll para hacer el salto sin notarse
          if (scrollTimer) clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function () {
            track.style.scrollBehavior = 'auto';
            track.scrollLeft = track.scrollLeft - w;
            track.style.scrollBehavior = '';
          }, 80);
        }
        lastScroll = track.scrollLeft;
      }, { passive: true });

      prevBtn.addEventListener('click', prev);
      nextBtn.addEventListener('click', next);
      window.addEventListener('resize', buildClones);

      // Autoplay opcional
      var autoplay = root.dataset.autoplay === 'true';
      var interval = parseInt(root.dataset.interval, 10) || 4000;
      var timer = null;
      function start() { if (!autoplay) return; stop(); timer = setInterval(next, interval); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('details[data-topbar-languages]').forEach(function (d) {
      let timer;
      const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (supportsHover) {
        d.addEventListener('mouseenter', function () { clearTimeout(timer); d.open = true; });
        d.addEventListener('mouseleave', function () { timer = setTimeout(function () { d.open = false; }, 150); });
      }
      document.addEventListener('click', function (e) {
        if (d.open && !d.contains(e.target)) d.open = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.section-usp-row').forEach(function (root) {
      var track = root.querySelector('[data-usp-track]');
      var dots = root.querySelectorAll('[data-usp-dot]');
      if (!track || dots.length === 0) return;

      function update() {
        if (window.innerWidth >= 1024) return;
        var items = track.querySelectorAll('.usp-row-item');
        if (items.length === 0) return;
        var center = track.scrollLeft + track.clientWidth / 2;
        var idx = 0;
        var bestDist = Infinity;
        items.forEach(function (it, i) {
          var c = it.offsetLeft + it.offsetWidth / 2;
          var d = Math.abs(c - center);
          if (d < bestDist) { bestDist = d; idx = i; }
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === idx);
        });
      }

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(update);
      });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var items = track.querySelectorAll('.usp-row-item');
          if (items[i]) {
            track.scrollTo({ left: items[i].offsetLeft - track.clientWidth / 2 + items[i].offsetWidth / 2, behavior: 'smooth' });
          }
        });
      });

      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-ugc-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ugc-carousel]').forEach(function (root) {
    const track = root.querySelector('[data-ugc-track]');
    if (!track) return;

    root.addEventListener('click', function (e) {
      const nav = e.target.closest('[data-ugc-prev],[data-ugc-next]');
      if (nav) {
        const dir = nav.hasAttribute('data-ugc-next') ? 1 : -1;
        const card = track.querySelector('.ugc-card');
        const step = card ? card.getBoundingClientRect().width + 16 : 320;
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
        return;
      }
      const playBtn = e.target.closest('[data-ugc-play]');
      if (playBtn) {
        const card = playBtn.closest('.ugc-card');
        const video = card.querySelector('video');
        // pausar el resto
        track.querySelectorAll('.ugc-card.is-playing video').forEach(function (v) {
          if (v !== video) { v.pause(); v.closest('.ugc-card').classList.remove('is-playing'); }
        });
        video.controls = true;
        video.play();
        card.classList.add('is-playing');
        return;
      }
    });

    // al pausar/terminar, recuperar el botón de play
    track.addEventListener('pause', function (e) {
      if (e.target.tagName === 'VIDEO' && e.target.seeking === false) {
        const card = e.target.closest('.ugc-card');
        if (card && e.target.paused) { card.classList.remove('is-playing'); e.target.controls = false; }
      }
    }, true);

    // pausar vídeos fuera de pantalla
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          const v = entry.target.querySelector('video');
          if (!entry.isIntersecting && v && !v.paused) v.pause();
        });
      }, { root: track, threshold: 0.3 });
      track.querySelectorAll('.ugc-card').forEach(function (c) { io.observe(c); });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
